import { Container } from "@mui/material";

import Navigation from "../../../../components/header";

const LoadWeightsReport = () => {
	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<h1 className="report-header">Load Weights Report</h1>
				<iframe title="HWIOnline_LoadWeightsReport_DEV" width="1140" height="700" src="https://app.powerbi.com/reportEmbed?reportId=8a353d3c-1634-4670-834a-f93a6df81fb4&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2" frameBorder="1"></iframe>
			</Container>

		</>
	);
};

export default LoadWeightsReport;